/*********************************************************************
 * The Initial Developer of the content of this file is NETCONOMY.
 * All portions of the code written by NETCONOMY are property of
 * NETCONOMY. All Rights Reserved.
 *
 * NETCONOMY Software & Consulting GmbH
 * Hilmgasse 4, A-8010 Graz (Austria)
 * FN 204360 f, Landesgericht fuer ZRS Graz
 * Tel: +43 (316) 815 544
 * Fax: +43 (316) 815544-99
 * www.netconomy.net
 *
 * (c) 2019 by NETCONOMY Software & Consulting GmbH
 *********************************************************************/

import logger from '../utils/rbmc.logger';
import gigyaCustom from './rbmc.gigya';

// screen ids
const CDC_FORGOTTEN_PASS_SCREEN            = 'gigya-forgot-password-screen';
const CDC_REGISTRATION_COMPLETITION_SCREEN = 'gigya-complete-registration-screen';
const CDC_REGISTRATION_SCREEN              = 'gigya-register-screen';

//fields

const CDC_NL_EMAIL_FIELD = 'subscriptions.newsletter.email.isSubscribed';

const gigyaRegisterLogin = {

    bindHandler: () => {
        // Called after a new screen is rendered.
        document.addEventListener('gigya-registration-login-after-screenload', gigyaRegisterLogin.afterScreenLoad);
        // Called when an error occurs.
        document.addEventListener('gigya-registration-login-error', gigyaRegisterLogin.registrationLoginError);
        // Called after a form is submitted.
        document.addEventListener('gigya-registration-login-after-submit', gigyaRegisterLogin.registrationLoginAfterSubmit);
        // Called when a field is changed in a managed form.
        document.addEventListener('gigya-registration-login-field-change', gigyaRegisterLogin.registrationLoginAfterFieldChange);

        document.addEventListener('gigya-registration-on-submit', gigyaCustom.clearUncheckedSubscriptions);
    },

    afterScreenLoad: evt => {
        gigyaCustom.showPasswordCheckbox();
        const $form_container = $('#cdc-gigya-register-container');
        const data            = evt.detail;
        /**
         * Delegate click on label to radio button
         */
        if (data.currentScreen === CDC_REGISTRATION_SCREEN) {
            const $nl_choice = $('.registration-nl__choice');
            $nl_choice.on('click', 'label', function (evt) {
                const $this = $(evt.target);
                $this.siblings('input[type="radio"]').click();
            });

            /**
             * Wrap elements to create suitable structure for scss
             */
            $form_container.find('.wrap-element').wrapAll('<div class="registration-nl__additional d-none">');
            $form_container.find('.wrap-element-date').wrapAll('<div class="registration-nl__date-fields">');
            $form_container.find('.wrap-element-date:not(:last-child)').after('<span class="date-delimiter"></span>');

            /**
             * Prefill newsletter language based on current shop language
             */
            const $languageField = $form_container.find('[name="data.ns.language"]')
            $languageField.find(`option[value="${RedBull.config.language}"]`) ?
                    $languageField.val(RedBull.config.language) :
                    $languageField.val('en');
        }

        if (data.currentScreen === CDC_REGISTRATION_COMPLETITION_SCREEN) {
            const $regCompletitionForm   = $('#gigya-complete-registration-screen'),
                  $consentCheckbox       = $regCompletitionForm.find('input[name*="privacy.redbullshop"]'),
                  $mandatoryConsentLabel = $regCompletitionForm.find('.consent-mandatory');

            $('.gigya-input-submit').one('click', function () {
                if (!$consentCheckbox.prop('checked')) {
                    $mandatoryConsentLabel.show();
                }
            });

            $consentCheckbox.on('change', function () {
                !$consentCheckbox.prop('checked') ? $mandatoryConsentLabel.show() : $mandatoryConsentLabel.hide()
            });
        }
    },

    registrationLoginError: evt => {
        let data = evt.detail;

        // RBMC login page (account and checkout)
        if (data.sourceContainerID === 'cdc-login-page-container' || data.sourceContainerID === 'cdc-login-checkout-container') {
            gigyaCustom.renderGlobalMessages(data.response.errorMessage);
        }

        // RBMC register page
        if (data.sourceContainerID === 'cdc-gigya-register-container') {
            gigyaCustom.renderGlobalMessages(data.response.errorMessage);
            $(window, document).scrollTop(0);
        }

        // RBMC register page
        if (data.sourceContainerID === 'cdc-gigya-reset-pass-container') {
            gigyaCustom.renderGlobalMessages(data.response.errorMessage);
            $(window, document).scrollTop(0);
        }
    },

    registrationLoginAfterSubmit: evt => {
        let data = evt.detail;
        gigyaRegisterLogin.redirect(data);
    },

    registrationLoginAfterFieldChange: evt => {
        let data = evt.detail;
        // be aware there are always two inputfields with the same name in the DOM (one is hided by CDC)
        let $targetInput           = $(`.gigya-screen-content [name="${data.field}"]`);
        let $gigyaCompositeControl = $targetInput.closest('.gigya-composite-control');

        if (data.isValid) {
            $gigyaCompositeControl.removeClass('gigya-composite-control--error')
        } else {
            $gigyaCompositeControl.addClass('gigya-composite-control--error')
        }

        // Check if newlsetter radiobutton value changed
        if (data.field === CDC_NL_EMAIL_FIELD) {
            data.value === 'true' ?
                    gigyaRegisterLogin.showAdditionalNewlsetterFields() :
                    gigyaRegisterLogin.showAdditionalNewlsetterFields(false);
        }
    },

    showAdditionalNewlsetterFields(state = true) {
        const $nl_group = $('.registration-nl__additional');
        state ? $nl_group.removeClass('d-none') : $nl_group.addClass('d-none');
    },

    redirect: data => {

        var cdcResponseStatus = data.response.status;

        // an error on form validation occurred
        if (cdcResponseStatus === 'FAIL') {
            // do nothing, form should show error message
            return;
        } else if (cdcResponseStatus === 'OK') {

            if (data.screen === CDC_FORGOTTEN_PASS_SCREEN) {
                // redirect to forgot password success page

                var email = data.response.requestParams.loginID;

                if (!(typeof email === 'string')) {
                    email = "";
                }

                window.location.href = `${ACC.config.encodedContextPath}/password-reset?emailsent=true&email=${email}`;
            }

        } else {
            logger.log("Error: unexpected status returned from CDC server, response is " + cdcResponseStatus);
        }
    }
};

export default gigyaRegisterLogin;
